import { InitializeSessionResponseDTO } from "../interfaces/pay-dto";
import { PaymentSession } from "@/models/payment/interfaces/payment";

export const mapInitializeSessionResponseDTOtoPaymentSession = (resp: InitializeSessionResponseDTO): PaymentSession => {
  let paymentSessionKey = "";
  const regex = new RegExp('[?&]sessionKey(=([^&#"]*)|&|#|$)"'),
    results = regex.exec(resp.iframe);
  if (results && results[2]) {
    paymentSessionKey = decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  const mappedResponse: PaymentSession = {
    paymentSessionToken: resp.session_token || "",
    paymentSessionKey,
    iframe: resp.iframe || ""
  };

  return mappedResponse;
};
